import { ComponentType, lazy, LazyExoticComponent, Suspense } from 'react';
import classNames from 'classnames';

import { useAppStore, type IAppStore } from '@/store';
import { Screen } from '@/types';
import useStyles from './styles';

import MobileCreate from '@/components/MobileCreate';

const Loading = lazy(() => import('@/components/Loading'));
const Generations = lazy(() => import('@/components/Generations'));
const CategoryRowsHome = lazy(() => import('@/components/CategoryRowsHome'));

const selector = (store: IAppStore) => ({ screen: store.screen });

const overlayComponents: Partial<
  Record<Screen, LazyExoticComponent<ComponentType> | ComponentType>
> = {
  [Screen.Loading]: Loading,
  [Screen.Files]: Generations,
  [Screen.Library]: CategoryRowsHome,
};

const MobileLayout = () => {
  const { screen } = useAppStore(selector);
  const classes = useStyles();

  const isFeedOpen = screen === Screen.Create;
  const baseScreen = isFeedOpen ? Screen.Library : screen;
  const BaseScreen = overlayComponents[baseScreen];

  return (
    <div className={classes.mobileContent}>
      {BaseScreen && (
        <div
          className={classNames(classes.screenLayer, {
            [classes.hiddenLayer]: isFeedOpen,
          })}
        >
          <Suspense fallback={null}>
            <BaseScreen />
          </Suspense>
        </div>
      )}
      {isFeedOpen && <MobileCreate />}
    </div>
  );
};

export default MobileLayout;
